export default __webpack_public_path__ + "static/media/QRCode.0b521e33.png";